import React from "react";
import {Skeleton, TableCell, TableRow} from "@mui/material";

const SkeletonFrame = () => {
  return (
    <>
      <Skeleton variant="text" />
      {/* <Skeleton variant="text" width={240} height={24} /> */}
    </>
  );
};

type SkeletonType = {
  row: number;
  column: number;
};

const MWSkeleton = ({row, column}: SkeletonType) => {
  return (
    <>
      {[...Array(row)].map((row, index1) => (
        <TableRow key={index1}>
          {[...Array(column)].map((column, index2) => (
            <TableCell key={index2} align="center">
              <SkeletonFrame />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};

export default MWSkeleton;
